import { Button, Checkbox, DialogContent, DialogTitle, FormControlLabel, Stack, Typography } from "@mui/material";
import DialogButtons from "@entrilia/shared/components/DialogButtons";
import DialogCloseButton from "@entrilia/shared/components/DialogCloseButton";
import SmallDialog from "@entrilia/shared/components/SmallDialog";

interface Props {
  open: boolean;
  canIncludeFiles: boolean;
  includeFiles: boolean;
  isStarting: boolean;
  userEmail?: string;
  onClose: () => void;
  onIncludeFilesChange: (value: boolean) => void;
  onStartExport: () => void;
}

const DocumentCollectionsExportDialog = ({
  open,
  canIncludeFiles,
  includeFiles,
  isStarting,
  userEmail,
  onClose,
  onIncludeFilesChange,
  onStartExport,
}: Props) => {
  const handleClose = () => {
    if (isStarting) {
      return;
    }

    onClose();
  };

  return (
    <SmallDialog
      open={open}
      onClose={(_, reason) => {
        if (isStarting && (reason === "backdropClick" || reason === "escapeKeyDown")) {
          return;
        }

        onClose();
      }}
    >
      <DialogTitle>Export existing document collections</DialogTitle>
      {!isStarting && <DialogCloseButton onClick={handleClose} />}
      <DialogContent>
        <Stack spacing={2}>
          <Typography color="textSecondary">CSV metadata will be generated now.</Typography>

          {canIncludeFiles && (
            <FormControlLabel
              label="Include uploaded files (.zip)"
              control={<Checkbox checked={includeFiles} onChange={(_, checked) => onIncludeFilesChange(checked)} />}
              disabled={isStarting}
            />
          )}

          {canIncludeFiles && includeFiles && (
            <Stack spacing={0.5}>
              <Typography color="textSecondary">&bull; ZIP creation may complete later than CSV generation.</Typography>
              <Typography color="textSecondary">
                &bull; Download links will be sent to: <strong>{userEmail ?? "your current account email"}</strong>.
              </Typography>
              <Typography color="textSecondary">&bull; Links expire in 7 days.</Typography>
              <Typography color="textSecondary">
                &bull; The email may arrive later because file package creation can take more time than CSV creation.
              </Typography>
            </Stack>
          )}
        </Stack>
      </DialogContent>
      <DialogButtons onCancel={onClose} cancelDisabled={isStarting}>
        <Button variant="contained" loading={isStarting} onClick={onStartExport}>
          Start export
        </Button>
      </DialogButtons>
    </SmallDialog>
  );
};

export default DocumentCollectionsExportDialog;
